import { AxiosResponse } from 'axios'
import { environments } from 'environments/environments'
import {
    CreateNotificationDTO,
    NotificationItem,
    NotificationsQuery
} from 'interfaces/Notifications'
import { TypeModalNotification } from 'pages/components/ModalNotification'
import { removeEmptyValues } from 'utils/removeEmptyValues'
import api from './api'

const { ENDPOINT_API_USERS } = environments

const getNotifications = async (
    idUser: string
): Promise<AxiosResponse<TypeModalNotification[]>> => {
    return api.get(`${ENDPOINT_API_USERS}/usuarios/${idUser}/mensagens`)
}

const getListNotifications = (
    idUser: string,
    query: NotificationsQuery
): Promise<AxiosResponse<NotificationItem[]>> => {
    const cleanEmptyValues: Record<string, any> = removeEmptyValues(query)
    const queryParams = new URLSearchParams({ ...cleanEmptyValues })

    return api.get(
        `${ENDPOINT_API_USERS}/usuarios/${idUser}/all-mensagens?${queryParams}`
    )
}

const deleteNotification = (
    idUser: string,
    idNotification: string
): Promise<AxiosResponse<NotificationItem[]>> => {
    return api.delete(
        `${ENDPOINT_API_USERS}/usuarios/${idUser}/mensagens/${idNotification}`
    )
}

const createNotification = async (
    data: CreateNotificationDTO
): Promise<void> => {
    return api.post(`${ENDPOINT_API_USERS}/usuarios/mensagens`, { ...data })
}

const visualizeNotification = async (
    idUser: string,
    guidMessage: Array<string>
): Promise<void> => {
    return api.post(`${ENDPOINT_API_USERS}/usuarios/${idUser}/mensagens`, {
        guidMessage
    })
}

export {
    createNotification,
    deleteNotification,
    getListNotifications,
    getNotifications,
    visualizeNotification
}
